module.exports = __webpack_public_path__ + "img/mobilebanner3.a2261abd.png";